<button [ngClass]="{
  'button--outline': outline, 
  'button--primary': !outline, 
  'button--blue': outline, 
  'responsive-icon': (leftIconPath || rightIconPath),
  'large': size === 'lg',
  'cal-large': size === 'cal-lg',
  'full': size === 'cal-full'
}"
  (click)="_onClick" (mouseenter)="_onHover(true)" (mouseleave)="_onHover(false)" style="margin-bottom: 10px;">
  <img *ngIf="leftIconPath" [src]="isHover ? leftIconSecondaryPath: leftIconPath" alt="prev" />
  <span>{{text}}</span>
  <img *ngIf="rightIconPath" [src]="isHover ? rightIconSecondaryPath : rightIconPath" alt="next" />
</button>